<template>
  <section class="box-user" @click="$emit('click', 3244)">
    <div class="edit-box">
      <b-dropdown aria-role="list">
        <template #trigger>
          <div class="trigger-dropdown">
            <div>
              <svg width="10" height="10" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.32287 1.16874L0.471378 5.02051C0.452002
               5.03994 0.43801 5.06448 0.431348 5.09086L0.00444662
               6.80435C-0.00832322 6.85592 0.00683403 6.91078 0.0444773
                6.94842C0.0729595 6.97691 0.111769 6.99267 0.151466
                 6.99267C0.163625 6.99267 0.176062 6.99117 0.188166
                  6.98812L1.90166 6.56116C1.92836 6.5545 1.95262 6.54057
                  1.972 6.52119L5.82383 2.66969L4.32287 1.16874Z" fill="#666666"
                />
                <path d="M6.77802 0.643537L6.34929 0.214804C6.06275
              -0.0717401 5.56334 -0.0714625 5.27713 0.214804L4.75195
               0.739977L6.25285 2.24088L6.77802 1.7157C6.92116 1.57263
               7 1.38219 7 1.17965C7 0.977108 6.92116 0.78667 6.77802
                0.643537Z" fill="#666666"
                />
              </svg>
            </div>
            <feather type="chevron-down" size="17px" />
          </div>
        </template>

        <b-dropdown-item aria-role="listitem">
          Action
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem">
          Another action
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem">
          Something else
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <img class="img-box" src="../../../assets/icons/1602006586025.png" alt="Logo da Empresa">
    <span class="empresa-name">DPC DISTRIBUIDOR ATACADISTA S/A</span>
    <div class="basic-info">
      <span class="text__right">VISTO POR ÚLTIMO</span>
      <span class="text__left">30 min atrás</span>
    </div>
    <div class="basic-info">
      <span class="text__right">ÚLTIMA COMPRA</span>
      <span class="text__left">27/03/2021</span>
    </div>
    <div class="basic-info">
      <span class="text__right">MÉDIA DE ACESSO</span>
      <span class="text__left">10 min</span>
    </div>
  </section>
</template>

<script>

export default {

};

</script>

<style scoped>

.trigger-dropdown {
  background-color: #E2EAF5;
  width: 50px;
  padding: 1px 7px 1px 7px;
  display: flex;
  border-radius: 3px;
  align-items: center;
  justify-content: space-between;
}

.edit-box {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.text__right {
    font-size: 12px;
}
.text__left {
    font-size: 12px;
    font-weight: bold;
}

.basic-info {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-bottom: 6px;
    margin-top: 20px;
    border-bottom: 2px solid #E2EAF5;
}
.box-user {
    width: 23%;
    padding: 28px;
    margin-top: 25px;
    border-radius: 3px;
    display: flex;
    background-color: white;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px solid #E2EAF5;
    transition: 0.3s ease-in-out;
    cursor: pointer;
}

.box-user:hover {
  transform: scale(1.04);
   border: 2px solid #219653;
}

.img-box {
    width: 110px;
    border-radius: 50%;
    padding: 3px;
    border: solid 3px #FF0E0E;
}
.empresa-name {
    margin-top: 30px;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: center;
    font-size: 12px;
}

</style>
